import React, { useEffect, useState } from 'react'
import { Select } from '@arco-design/web-react'
import {
  getBookLibraryKeywordBooks,
  getBookLibraryKeywordOutlines,
} from './utils/api'
import Empty from './Empty'

const Option = Select.Option

interface Props {
  category: 'BOOK_KEYWORDS' | 'OUTLINE_KEYWORDS'
  disabled: boolean
  value: string
  setValue: (string: string) => void
}

const KeywordsBook = (props: Props) => {
  const {
    disabled,
    category, // 类别
    value, // 关键字选择值
    setValue,
  } = props

  // 所有数据
  const [keywordArray, setKeywordArray] = useState<Array<string>>([])
  // 刷新状态
  const [state, setState] = useState<boolean>(false)
  // 输入值
  const [keywordValue, setKeywordValue] = useState<string>('')
  // 接口是否出错需要刷新获取
  const [isError, setIsError] = useState<boolean>(false)

  // 书籍关键字
  const getKeywordBooksBack = (value: string) => {
    setState(true)
    getBookLibraryKeywordBooks(value)
      .then((res) => {
        if (res.status == 200) {
          let data = res.data
          let arr = []
          data.forEach((item, index) => {
            arr.push(item.book.properties.name)
          })
          setKeywordArray(arr)
          setState(false)
          setIsError(false)
        } else {
          setKeywordArray([])
          setState(false)
          setIsError(true)
        }
      })
      .catch((err) => {
        setKeywordArray([])
        setState(false)
        setIsError(true)
      })
  }

  // 大纲关键字
  const getKeywordOutlinesBack = (value: string) => {
    setState(true)
    getBookLibraryKeywordOutlines(value)
      .then((res) => {
        if (res.status == 200) {
          let data = res.data
          let arr = []
          data.forEach((item, index) => {
            arr.push(item.nav.properties.name)
          })
          setKeywordArray(arr)
          setState(false)
          setIsError(false)
        } else {
          setKeywordArray([])
          setState(false)
          setIsError(true)
        }
      })
      .catch((err) => {
        setKeywordArray([])
        setState(false)
        setIsError(true)
      })
  }

  // 防抖
  function createDelayHandler(callback, delay = 500) {
    let timer = null
    return (e) => {
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => callback(e), delay)
    }
  }

  return (
    <Select
      className={'red-input'}
      showSearch
      disabled={disabled}
      // allowCreate
      // placeholder="历史"
      allowClear
      value={value}
      onChange={setValue}
      onFocus={() => {
        setKeywordArray([])
        setKeywordValue(value)
        category === 'BOOK_KEYWORDS'
          ? getKeywordBooksBack(value)
          : category === 'OUTLINE_KEYWORDS'
          ? getKeywordOutlinesBack(value)
          : ''
      }}
      onKeyDown={createDelayHandler((e) => {
        const value = e.target.value
        // if (!value) return
        setKeywordArray([])
        setKeywordValue(value)
        category === 'BOOK_KEYWORDS'
          ? getKeywordBooksBack(value)
          : category === 'OUTLINE_KEYWORDS'
          ? getKeywordOutlinesBack(value)
          : ''
      }, 500)}
      notFoundContent={
        isError ? (
          <Empty
            onClick={() =>
              category === 'BOOK_KEYWORDS'
                ? getKeywordBooksBack(keywordValue)
                : category === 'OUTLINE_KEYWORDS'
                ? getKeywordOutlinesBack(keywordValue)
                : ''
            }
            state={state}
          />
        ) : (
          <Empty title="暂无数据！" state={state} />
        )
      }>
      {keywordArray.map((option) => (
        <Option key={option} value={option}>
          {option}
        </Option>
      ))}
    </Select>
  )
}

export default KeywordsBook
